import { createStyles, makeStyles } from '@material-ui/core';
import BookingsComponent from 'components/Bookings';
import { AbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookings';
import { BookingsNavbar } from 'components/Bookings2/Navbar/Navbar';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import { BookingDetailPath, BookingsAbandonedPath, BookingsGroomingPath, BookingsPath } from 'routes/Paths';
import AppointmentsWebSockets from 'WebSockets';
import PrivatePage from './PrivatePage';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            overflow: 'hidden',
            flexDirection: 'column'
        }
    })
);

export const Bookings: React.FC = () => {
    const classes = useStyles();

    return (
        <>
            <AppointmentsWebSockets />

            <PrivatePage
                pageName="/bookings"
                title="Bookings - Cuddles"
                pageContentClassName={classes.root}
            >
                <BookingsNavbar />

                <Switch>
                    <Route
                        path={BookingsAbandonedPath}
                        component={AbandonedBookings}
                    />
                    <Route
                        exact
                        path={BookingsGroomingPath}
                        component={BookingsComponent}
                    />
                    <Route
                        exact
                        path={BookingDetailPath}
                        component={() => <BookingsComponent showBookingDetail />}
                    />

                    <Redirect
                        path={BookingsPath}
                        to={BookingsGroomingPath}
                    />
                </Switch>
            </PrivatePage>
        </>
    );
};

export default withRouter(Bookings);
